import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login/login.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { EMAIL_REGEX } from 'src/app/utils/constante';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  public forgotPasswordForm: FormGroup;
  public captchaOK = false;
  public readonly recaptchaSiteKey = environment.recaptchaSiteKey;

  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private modalService: ModalService,
    private snackbarService: SnackbarService,
    private viewContainerRef: ViewContainerRef,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      login: ['', [Validators.required, Validators.pattern(EMAIL_REGEX)]],
    });
  }

  public resolved(captchaResponse: string): void {
    if (captchaResponse) {
      this.captchaOK = true;
    }
  }

  public async onSubmit(): Promise<void> {
    this.forgotPasswordForm.markAllAsTouched();
    if (!this.captchaOK) {
      this.snackbarService.openSnackBarError('Vous devez valider le captcha pour continuer.');
      return;
    }
    if (this.forgotPasswordForm.valid) {
      const loader = this.modalService.openLoading(this.viewContainerRef);
      try {
        await this.loginService.forgotPassword(this.forgotPasswordForm.get('login').value);
        this.modalService.close(loader);
        const modal = this.modalService.openAlert(this.viewContainerRef, 'Succès', 'Un email pour renouveler votre mot de passe vient d\'être envoyé à cette adresse, veuillez vérifier vos emails');
        const sub = modal.instance.closeEmitter.subscribe(() => {
          this.router.navigateByUrl('');
          sub.unsubscribe();
        });
      } catch (e) {
        this.modalService.close(loader);
        throw e;
      }
    }
  }
}
